module.exports = __webpack_public_path__ + "static/media/verify-success.625ec1cd.svg";